import React, { useState } from 'react';
import { useLanguage } from '../hooks/useLanguage';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const {
    language,
    setLanguage,
    t
  } = useLanguage();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'de' : 'en');
  };
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
      setIsMenuOpen(false);
    }
  };
  return <nav className="sticky top-0 z-50 w-full px-4 pt-3" data-id="element-86">
      <div className="max-w-7xl mx-auto bg-white/90 backdrop-blur-md border-b border-[#152c61]/[0.04] rounded-2xl h-16 px-6 transition-all duration-300 shadow-[0_2px_10px_rgba(0,0,0,0.02)]" data-id="element-87">
        <div className="flex justify-between items-center h-full" data-id="element-88">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center group cursor-pointer" onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })} data-id="element-89">
            <img src="https://cdn.magicpatterns.com/uploads/1KjJp5xeK4U55Vnfvx1z87/1758182731791.jpg" alt="LangeBjergGård Consulting" className="h-9 w-auto object-contain" data-id="element-90" />
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-91">
            <button onClick={() => scrollToSection('services')} className="text-[13px] font-medium text-[#152c61]/80 hover:text-[#152c61] uppercase tracking-[0.15em] transition-colors" data-id="element-92">
              {t.nav.services}
            </button>
            <button onClick={() => scrollToSection('about')} className="text-[13px] font-medium text-[#152c61]/80 hover:text-[#152c61] uppercase tracking-[0.15em] transition-colors" data-id="element-93">
              {t.nav.about}
            </button>

            {/* Language Toggle */}
            <button onClick={toggleLanguage} className="text-[11px] font-medium text-[#152c61]/50 hover:text-[#ae6470] uppercase tracking-widest cursor-pointer transition-colors" data-id="element-94">
              {language === 'en' ? 'DE' : 'EN'}
            </button>

            {/* CTA Button */}
            <button onClick={() => scrollToSection('contact')} className="bg-gradient-to-r from-[#152c61] to-[#1a3470] text-white px-5 py-2 rounded-full text-[12px] font-semibold uppercase tracking-wider hover:shadow-[0_4px_12px_rgba(21,44,97,0.2)] transition-all transform hover:-translate-y-0.5" data-id="element-95">
              {t.nav.contact}
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center" data-id="element-96">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-[#152c61] p-2 hover:bg-gray-50 rounded-lg transition-colors" aria-label="Toggle menu" data-id="element-97">
              {isMenuOpen ? <X size={20} data-id="element-98" /> : <Menu size={20} data-id="element-99" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && <div className="md:hidden mx-4 mt-2 bg-white border border-[#152c61]/5 rounded-2xl shadow-lg overflow-hidden" data-id="element-100">
          <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-101">
            <button onClick={() => scrollToSection('services')} className="block w-full text-left px-4 py-3 text-[#152c61] font-medium hover:bg-gray-50 rounded-lg transition-colors uppercase text-xs tracking-widest" data-id="element-102">
              {t.nav.services}
            </button>
            <button onClick={() => scrollToSection('about')} className="block w-full text-left px-4 py-3 text-[#152c61] font-medium hover:bg-gray-50 rounded-lg transition-colors uppercase text-xs tracking-widest" data-id="element-103">
              {t.nav.about}
            </button>
            <button onClick={() => scrollToSection('contact')} className="block w-full text-left px-4 py-3 text-[#152c61] font-medium hover:bg-gray-50 rounded-lg transition-colors uppercase text-xs tracking-widest" data-id="element-104">
              {t.nav.contact}
            </button>
            <div className="pt-4 px-4" data-id="element-105">
              <button onClick={() => {
            toggleLanguage();
            setIsMenuOpen(false);
          }} className="flex-1 w-full py-3 rounded-lg border border-gray-100 text-[#152c61] font-medium text-center hover:bg-gray-50 transition-colors uppercase text-xs tracking-widest" data-id="element-106">
                {language === 'en' ? 'DE' : 'EN'}
              </button>
            </div>
          </div>
        </div>}
    </nav>;
}